
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BaseCard extends Vue {
  @Prop({ required: true }) id!: string;
  @Prop({ required: false, default: false }) dense!: boolean;
}
